import { render } from "./CheckboxComponent.vue?vue&type=template&id=7d9a54c7"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"

import "./CheckboxComponent.vue?vue&type=style&index=0&id=7d9a54c7&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__